import type { Currency } from "@/lib/domain/Currency";
import { useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import { useQueryClient, type MutationFunction } from "@tanstack/react-query";

export interface SetPreferredCurrencyRequestModel {
	readonly currency: Currency;
}

export const useSetPreferredCurrency = () => {
	const http = useHTTP("Required");
	const queryClient = useQueryClient();

	const mutationFn: MutationFunction<HTTPResponse, SetPreferredCurrencyRequestModel> = requestModel => {
		return http<undefined, SetPreferredCurrencyRequestModel>({
			method: "POST",
			url: "/settings/preferred-currency",
			body: requestModel
		});
	};

	return useHTTPMutation({
		mutationFn,
		onSuccess: (_, requestModel) => {
			queryClient.resetQueries();
			queryClient.setQueryData(["preferredCurrency"], requestModel);
		}
	});
};
